import { PopupManager } from '../../popups/PopupManager';

export class DisabledPopupManager extends PopupManager {

    public invoke() {
        return Promise.resolve({ actioned: false, data: null });
    }

}
